// src/components/auth-nav.js

import React from "react";
import AuthenticationButton from "./Authentication-button";

const AuthNav = () => (
  <div className="navbar-nav ml-auto">
    <AuthenticationButton />
  </div>
);

export default AuthNav;